import type { ToastItem } from '../store/state';
import { Button } from './Button';
import { Icon } from './Icon';

const M: Record<ToastItem['kind'], { color: string; icon: string }> = {
  info: { color: 'var(--accent)', icon: 'sparkles' },
  success: { color: 'var(--ok)', icon: 'check-circle-2' },
  warning: { color: 'var(--warn)', icon: 'hand' },
  danger: { color: 'var(--danger)', icon: 'octagon-alert' },
};

export function ToastStack({
  items,
  onClose,
  onAction,
}: {
  items: ToastItem[];
  onClose: (id: string) => void;
  onAction: (t: ToastItem) => void;
}) {
  if (items.length === 0) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 400,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {items.map((t) => {
        const m = M[t.kind];
        return (
          <div
            key={t.id}
            className="anim-toast"
            style={{
              width: 360,
              maxWidth: 'calc(100vw - 32px)',
              background: 'var(--panel)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-lg)',
              boxShadow: 'var(--shadow-2)',
              overflow: 'hidden',
              display: 'flex',
            }}
          >
            <span style={{ width: 3, flex: 'none', background: m.color }} />
            <div style={{ padding: '10px 12px', flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: m.color, display: 'grid', flex: 'none' }}>
                  <Icon name={m.icon} size={16} />
                </span>
                <span className="t-strong" style={{ flex: 1, minWidth: 0 }}>
                  {t.title}
                </span>
                <Button
                  variant="icon"
                  icon="x"
                  aria-label="Chiudi"
                  onClick={() => onClose(t.id)}
                  style={{ width: 20, height: 20 }}
                />
              </div>
              {(t.body || t.actionLabel) && (
                <div className="t-caption dim" style={{ marginTop: 2 }}>
                  {t.body}
                  {t.actionLabel && (
                    <>
                      {' · '}
                      <button
                        onClick={() => onAction(t)}
                        style={{
                          border: 'none',
                          background: 'none',
                          color: 'var(--accent)',
                          cursor: 'pointer',
                          padding: 0,
                          font: 'inherit',
                        }}
                      >
                        {t.actionLabel}
                      </button>
                    </>
                  )}
                </div>
              )}
              {!t.sticky && (
                <div style={{ height: 2, background: 'var(--bg-2)', marginTop: 8 }}>
                  <div style={{ height: 2, background: m.color, width: '38%' }} />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
